import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bab8df0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_header" }
const _hoisted_2 = { class: "account_info" }
const _hoisted_3 = { class: "invoice_month" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "small" }, "年", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "small" }, "月", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "請求分", -1))
const _hoisted_7 = { class: "remain_count" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "残り", -1))
const _hoisted_9 = { class: "count" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "件", -1))


import { useRouter } from "vue-router";
import Icon from "@/components/common/Icon.vue";
import { ICompanyInvoice } from "@/models/company-invoice";

interface IProps {
  companyInvoice: ICompanyInvoice;
  remainCompanyInvoices: ICompanyInvoice[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CardHeader',
  props: {
    companyInvoice: {},
    remainCompanyInvoices: {}
  },
  setup(__props: any) {



const router = useRouter();
const onClickAccountName = (companyId: number) => {
  router.push({ name: "cs-company-edit", params: { id: companyId } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", {
        class: "account_name",
        onClick: _cache[0] || (_cache[0] = () => onClickAccountName(_ctx.companyInvoice.id))
      }, [
        _createTextVNode(_toDisplayString(_ctx.companyInvoice.company_name) + " ", 1),
        _createVNode(Icon, {
          "icon-name": "icon_edit",
          "icon-circle": "",
          "class-name": "account_edit_icon"
        })
      ]),
      _createElementVNode("h2", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.companyInvoice.year), 1),
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(_ctx.companyInvoice.month), 1),
        _hoisted_5,
        _hoisted_6
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.remainCompanyInvoices.length + 1), 1),
      _hoisted_10
    ])
  ]))
}
}

})